<template>
  <span class="scaling-svg-container">
    <svg
      id="Icon_Close_X"
      data-name="Icon/Close X"
      xmlns="http://www.w3.org/2000/svg"
      width="14.376"
      height="14.376"
      viewBox="0 0 14.376 14.376"
      class="scaling-svg"
    >
      <path
        id="Icon_Icon_Close_-_X"
        data-name="Icon/Icon/Close - X"
        d="M8.882,7.188l5.143-5.143A1.2,1.2,0,0,0,12.331.351L7.188,5.494,2.045.351A1.2,1.2,0,1,0,.351,2.045L5.494,7.188.351,12.331a1.2,1.2,0,1,0,1.694,1.694L7.188,8.882l5.143,5.143a1.2,1.2,0,0,0,1.694-1.694Z"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class ClearIcon extends Vue {}
</script>

<style>
</style>
